// ── 출퇴근/연차 위젯 (Mini Row, 2026-06-06 정리) ────────────────────────────
// 사용자 결정: my_attendance_monthly, my_leave_upcoming 제거.
// 유지: my_attendance_toggle, my_leave_balance

import React from 'react';
import { Clock, CalendarDays } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { MiniRow } from './MiniRow';

// ── 1. 내 출퇴근 토글 ────────────────────────────────────────────────────────
// 큰 토글 버튼 (text-base font-black, 상태 색상). watermarkIcon: Clock.
export function MyAttendanceToggleMini({ attendance, actionLoading, onCheckIn, onCheckOut, accentOverride, sortableId, onClick }) {
  const checkedIn = Boolean(attendance?.checked_in);
  const checkedOut = Boolean(attendance?.checked_out);

  const valueArea = checkedOut ? (
    <span className="flex flex-col items-end gap-1">
      <span className="text-base font-black text-slate-700 dark:text-slate-300">
        근무 종료
      </span>
      <span className="text-[11px] text-[var(--text-muted)] whitespace-nowrap font-semibold tabular-nums">
        {attendance?.check_in_time ? `${attendance.check_in_time}` : ''}
        {attendance?.check_out_time ? `~${attendance.check_out_time}` : ''}
      </span>
    </span>
  ) : checkedIn ? (
    <button
      onClick={onCheckOut}
      onPointerDown={(e) => e.stopPropagation()}
      disabled={actionLoading}
      className={cn(
        'px-4 py-2 rounded-md text-base font-black flex-shrink-0',
        'bg-slate-700 hover:bg-slate-800 text-white transition-colors',
        'dark:bg-slate-600 dark:hover:bg-slate-700',
        actionLoading && 'opacity-50 cursor-not-allowed'
      )}
    >{actionLoading ? '…' : '퇴근'}</button>
  ) : (
    <button
      onClick={onCheckIn}
      onPointerDown={(e) => e.stopPropagation()}
      disabled={actionLoading}
      className={cn(
        'px-4 py-2 rounded-md text-base font-black flex-shrink-0',
        'bg-emerald-600 hover:bg-emerald-700 text-white transition-colors',
        'dark:bg-emerald-500 dark:hover:bg-emerald-600',
        actionLoading && 'opacity-50 cursor-not-allowed'
      )}
    >{actionLoading ? '…' : '출근'}</button>
  );

  return (
    <MiniRow
      icon={Clock}
      label="출퇴근"
      accent="emerald"
      accentOverride={accentOverride}
      width={checkedOut ? 'wide' : 'narrow'}
      size="S"
      sortableId={sortableId}
      watermarkIcon={Clock}
      onClick={onClick}
    >
      {valueArea}
    </MiniRow>
  );
}

// ── 2. 내 연차 잔여 ──────────────────────────────────────────────────────────
// 큰 숫자 (text-3xl font-black emerald 명세). 단위 = "일". watermarkIcon: CalendarDays.
export function MyLeaveBalanceMini({ data, accentOverride, sortableId, onClick }) {
  if (!data) return <MiniRow icon={CalendarDays} label="남은 연차" accent="orange" accentOverride={accentOverride} size="S" loading sortableId={sortableId} watermarkIcon={CalendarDays} onClick={onClick} />;
  if (!data.allowed) return <MiniRow icon={CalendarDays} label="남은 연차" accent="orange" accentOverride={accentOverride} size="S" denied sortableId={sortableId} watermarkIcon={CalendarDays} />;
  const remaining = Number(data.remaining ?? 0);
  return (
    <MiniRow
      icon={CalendarDays}
      label="남은 연차"
      accent="orange"
      accentOverride={accentOverride}
      width="narrow"
      size="S"
      sortableId={sortableId}
      watermarkIcon={CalendarDays}
      onClick={onClick}
    >
      <span className="inline-flex items-baseline gap-1">
        <span className={cn(
          'text-3xl font-black tabular-nums leading-none whitespace-nowrap',
          remaining > 0 ? 'text-emerald-700 dark:text-emerald-300' : 'text-[var(--text-muted)]'
        )}>
          {remaining.toLocaleString()}
        </span>
        <span className="text-[11px] font-semibold text-[var(--text-sub)]">일</span>
      </span>
    </MiniRow>
  );
}
